import { atom } from "recoil";
import { Company } from "../apis";

const KEY = "user-company-list";

export const UserCompanyListAtom = atom<Company[]>({
    key: KEY,
    default: [],
});
